module.exports = __webpack_public_path__ + "static/img/pic_glptlogo@2x.e27a3cf2.png";